import React, {Component,Fragment} from 'react';
import {observer,inject,} from "mobx-react";
import {toJS,reaction} from "mobx";
import AutosizeInput from 'react-input-autosize';
import CodeSelector from "./CodeSelector";
import YesNo from "./FilterTypes/YesNo";
import ListSelector from "./FilterTypes/ListSelector";
// import SelectLinks from "./FilterTypes/SelectLinks";
import SectionSelector from "./FilterTypes/SectionSelector";
// import ElementSelector from "./FilterTypes/ElementSelector";
import FullList from "./FilterTypes/FullList";
import RemoteList from "./FilterTypes/RemoteList";
import Integer from "./FilterTypes/Integer";
import String from "./FilterTypes/String";
import Date from "./FilterTypes/Date";
import StaticList from "./FilterTypes/StaticList";
import {StoreContext} from "../../stores/contexts";

class Block extends Component {
  static contextType = StoreContext;

  getField() {
    return this.context.configStore.fields_by_code[this.props.item.code] || {};
  }
  getName() {
    const field=this.getField();

    return this.getField().name;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.item.focus) {
      if(this._inputRef) {
        if(!this.context.searchStore.disable_focus && !this.props.locked) {
          console.log('fire focus',this._inputRef);
          this._inputRef.focus();
          setTimeout(()=>{
            this.props.item.focus=0;
          },100);
        }
      }
    }
  }
  componentDidMount() {
    reaction(()=>{
      return this.props.item.focus;
    },()=>{
      if(!this.context.searchStore.disable_focus && !this.props.locked) {
        if(this._inputRef) {
          if(this.props.item.focus) {
            this._inputRef.focus();
            console.log('fire focus', this._inputRef);
            setTimeout(() => {
              this.props.item.focus = 0;
            }, 100);
          }
        }
      }
    },{ fireImmediately:true });
    // if(this.props.item.focus) {
    //   if (this._inputRef) {
    //     this._inputRef.focus();
    //   }
    //
    // }
  }
  getCompare(field) {
    if(field.compare) {
      return field.compare;
    }
    if(field.filter_type === "string") {
      return '~';
    }
    return '=';
  }
  lockMe() {
    if(!this.props.item.default) {
      const item = this.context.searchStore.blocks.splice(this.props.index, 1)[0];
      this.context.searchStore.locked_blocks.push(item);
      if(this.context.searchStore.blocks.length>0) {
        this.context.searchStore.blocks[this.context.searchStore.blocks.length-1].focus=1;
      }
    }
  }
  unlockMe() {
    const item=this.context.searchStore.locked_blocks.splice(this.props.index, 1)[0];
    this.context.searchStore.blocks.push(item);
  }
  removeMe() {
    if(this.context.searchStore.blocks.length>1 && !this.props.item.default) {
      this.context.searchStore.blocks[this.context.searchStore.blocks.length - 2].focus = 1;
      this.context.searchStore.blocks.splice(this.props.index, 1);
    }
  }
  inputRef(ref) {
    if(this.props.item.focus && ref) {
      // ref.focus();
    }
    this._inputRef = ref;
  }
  renderFilterControll() {
    if(this.props.item.code) {
      const type = this.getField().filter_type;
      let Comp=null;
      switch (type) {
        case "full_list":
          Comp=FullList;
          break;
        case "remote_list":
          Comp=RemoteList;
          break;
        case "static_list":
          Comp=StaticList;
          break;
        case "select_yes_no":
          if(this.props.locked) {
            if(this.props.item.value == '1') {
              return "Да";
            } else {
              return "Нет";
            }
          } else {
            return (
              <ListSelector
                relative={true}
                inputRef={(ref)=>{ this.inputRef(ref); }}
                item={this.props.item}
                fields={[ { code:"yes",name:"Да",value:"1" },{ code:"no",name:"Нет",value:"0" } ]}
                onNewFied={()=>{
                  this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus:0});
                }}
                onLock={()=>{
                  this.lockMe();
                }}
                onCancel={()=>{
                  this.removeMe();
                }}
                onSelect={(item)=>{
                  if(item) {
                    this.props.item.value = item.value;
                    this.props.item.focus = 1;
                  } else {
                    this.props.item.value = '';
                  }
                }}
                selected_value={this.props.item.value}
              />
            );
          }
        case "integer":
        case "decimal":
          Comp=Integer;
        break;
        case "string":
          Comp=String;
          break;
        case "date":
          Comp=Date;
          break;
      }

      if(Comp) {
        return (
          <Comp
            locked={this.props.locked}
            field={this.getField()}
            item={this.props.item}
            inputRef={(ref)=>{ this.inputRef(ref); }}
            onNewFied={()=>{
              this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus:0});
            }}
            onLock={()=>{
              this.lockMe();
            }}
            onKeyDown={(e)=> {
              if(e.shiftKey && e.ctrlKey && e.which == 76 && this.props.item.value) {
                e.preventDefault();
                e.stopPropagation();
                this.lockMe();
              }

              if (e.which === 8) {
                if (!this.props.item.value) {
                  e.preventDefault();
                  e.stopPropagation();
                  this.removeMe();
                }
              }
              if (e.which === 191 || e.which === 220) {
                e.preventDefault();
                e.stopPropagation();
                this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus: 0});
              }
            }}
            onCancel={()=>{
              this.removeMe();
            }}
            onSelect={(item)=>{
              console.log("focus on select");
              this.props.item.value=item.value;
              this.props.item.focus=1;
            }}
          />
        )
      }

      return null;

    }
    return (
      <div>
        &nbsp;
      </div>
    )
  }
  render() {
    console.log('block', toJS(this.context.searchStore.blocks));
    return (
      <div className={`dib pleft10 bg-w2 mright10 mbottom5 unlimitedFilterBlock ${this.props.item.code?"blockInited":"blockNotInited"}`}>
        <div className="up12 splice blockGrid">
          <span className="cell s-shrink pr s-middle blockTitle">
            {this.props.item.code?this.getName():(
              <div className="vpadd5 blockCodeSelector">
                <div className="z4">
                  <CodeSelector
                    relative={true}
                    onCancel={()=>{
                      this.removeMe();
                    }}
                    onSelect={(item)=>{
                      console.log('item', item);
                      this.props.item.code = item.code;
                      this.props.item.compare = this.getCompare(item);
                      this.props.item.focus = 1;
                  }} />
                </div>
              </div>
            )}
          </span>
          {!this.props.item.code?null:(
            <span className={`cell s-shrink hpadd5 bold s-middle blockCompare ${this.props.item.focus && !this.context.searchStore.disable_focus?'focusClass':''}`}>
              {this.props.item.compare}
            </span>
          )}
          {!this.props.item.code?null:(
            <span className="cell s-shrink s-middle vpadd5 blockInput">
              {this.renderFilterControll()}
            </span>
          )}
          {this.props.locked?(
            <span className="cell s-shrink s-middle vpadd5 pright5 pleft5 w4 b1-hover pointer blockLock" onClick={()=>{ this.unlockMe(); }}>
              <span className="mdi mdi-lock "></span>
            </span>
          ):(
            <>
              {this.props.index>0?(
                <span className="cell s-shrink s-middle vpadd5 pright5 pleft5 w4 b1-hover pointer blockClose" onClick={()=>{ this.removeMe(); }}>
                  <span className="mdi mdi-close "></span>
                </span>
              ):(
                <span className="cell s-shrink s-middle vpadd5 pright10 blockCloseBlank"></span>
              )}
            </>
          )}
        </div>
      </div>
    )
  }
}

// export default inject("searchStore","configStore")(observer(Block));
export default observer(Block);